export const isCallable = (input: any): input is Function => typeof input === 'function'

export const memoize = <T>(f: () => T): (() => T) => {
  let result: T
  return () => {
    if (typeof result !== 'undefined') {
      return result
    }
    result = f()
    return result
  }
}
